import { useState } from 'react'
import { useRecordContext } from 'react-admin'
import { Switch, FormControlLabel } from '@mui/material'
import get from 'lodash/get'

import useUpdateDataProvider from '../hooks/useUpdateDataProvider'

import { CHANNEL_STATUS, PODCAST_STATUS_DISPLAY } from './constants'

const ChannelStatusField = props => {
  const { disabled } = props
  const record = useRecordContext()

  const updateDataProvider = useUpdateDataProvider()
  const [status, setStatus] = useState(record.status)

  const handleChange = async () => {
    const data = {
      status:
        status === CHANNEL_STATUS.PUBLISHED
          ? CHANNEL_STATUS.UNPUBLISHED
          : CHANNEL_STATUS.PUBLISHED,
    }

    const response = await updateDataProvider(
      'channels',
      { id: record.id, data },
      {
        onSuccess: {
          notification: { body: 'Channel updated', level: 'info' },
          redirectTo: '/channels',
        },
        onFailure: {
          notification: {
            body: 'Error: Channel not updated',
            level: 'warning',
          },
        },
      },
    )
    if (get(response, 'data.status', null)) {
      setStatus(response.data.status)
    }
  }

  return [
    CHANNEL_STATUS.PUBLISHED,
    CHANNEL_STATUS.UNPUBLISHED,
    CHANNEL_STATUS.UNDER_REVIEW,
  ].includes(record.status) ? (
    <FormControlLabel
      control={
        <Switch
          checked={status === CHANNEL_STATUS.PUBLISHED}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={PODCAST_STATUS_DISPLAY[status]}
    />
  ) : (
    PODCAST_STATUS_DISPLAY[status]
  )
}

export default ChannelStatusField
